import React, { Suspense, lazy } from 'react';
import type { DirectoryMapProps } from './DirectoryMap';

// The map code (Leaflet, tiles, CSS) downloads only when a map is first shown (plan 13).
const DirectoryMap = lazy(() => import('./DirectoryMap'));

export default function LazyDirectoryMap(props: DirectoryMapProps) {
  return (
    <Suspense fallback={<div className={`${props.className ?? 'h-full w-full'} bg-fog animate-pulse`} />}>
      <DirectoryMap {...props} />
    </Suspense>
  );
}
